import ButtonLink from "@/Components/ButtonLink";
import React from "react";

interface InsightsCardProps {
  title: string;
  date: string;
  link: string;
  linkLabel?: string;
}

const InsightsCard: React.FC< InsightsCardProps> = ({ title,
  date,
  link,
  linkLabel = "Read more",
 }) => {
  let formattedDate = "";
  if (date) {
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      formattedDate = parsedDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } else {
      formattedDate = date; // fallback to original if parsing fails
    }
  }
  return (
    <div
      className="border border-border-light md:p-6 p-4 xl:pt-12 pt-5 relative h-full xl:min-h-[210px] md:min-h-[163px] lg:max-h-[163px] min-h-[190px] flex flex-col justify-end
    before:bg-[url(/images/Insights-sharss.webp)] before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center
    "
    >
      <div className="relative z-10">
        <h5 className="text-heading-6 font-bold text-primary-text line-clamp-2 xl:leading-[35px]! lg:leading-[31px]! leading-[30px]!">
          {title || ""}
        </h5>
        <div className="w-full flex justify-between items-center mt-3">
          <p className="text-secondary-text text-subtitle-3 font-regular">
            {formattedDate || ""}
          </p>
          {link && linkLabel && (
            <ButtonLink
              href={link}
              label={linkLabel}
              color="text-primary-text"
              stroke="stroke-primary-text"
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default InsightsCard;